import costs from "../../../assets/images/Images/Home-Images/image28.png";
import NPS from "../../../assets/images/Images/Home-Images/image28(1).png";
import image29 from "../../../assets/images/Images/Home-Images/image29.png";
import image30 from "../../../assets/images/Images/Home-Images/image30.png";
import management_1 from "../../../assets/images/Images/Home-Images/management_1.png";
import management_2 from "../../../assets/images/Images/Home-Images/management_2.png";
import Planning_1 from "../../../assets/images/Images/Home-Images/Planning_1.png";
import Planning_2 from "../../../assets/images/Images/Home-Images/Planning_2.png";
import execution_1 from "../../../assets/images/Images/Home-Images/execution_1.png";
import execution_2 from "../../../assets/images/Images/Home-Images/execution_2.png";
import execution_3 from "../../../assets/images/Images/Home-Images/execution_3.png";
import { useState } from "react";

type Props = {};

const Challenges = [
  {
    category: "MANAGEMENT",
    image: costs,
    moblieImage: management_1,
    title: "High Operational Costs",
    subTitle:
      "About 14% of service appointments* result in a second visit because of scheduling and dispatch errors.",
    footertext:
      " * These data points are generalized and can vary widely depending on specific industries within the field service sector, geographiclocation, company size, and management practices.",
  },
  {
    category: "MANAGEMENT",
    image: NPS,
    moblieImage: management_2,
    title: "Improving NPS",
    subTitle:
      "A Microsoft survey indicates that 61% of consumers now have higher customer service standards than they did just one year ago, and field services is not exempt from these expectations.",
  },
  {
    category: "PLANNING",
    image: image29,
    moblieImage: Planning_1,
    title: "Prioritization and Jeopardy",
    subTitle:
      "Field service organizations (FSOs) cite workforce scheduling and dispatch complexities as one of their top operational challenges.",
  },
  {
    category: "PLANNING",
    image: image30,
    moblieImage: Planning_2,
    title: "Efficient Capacity Planning",
    subTitle:
      "52% of field service organizations consider the aging workforce and the associated loss of skills as a significant challenge.",
  },
  {
    category: "EXECUTION",
    image: execution_1,
    moblieImage: execution_1,
    title: "Improving Technician Productivity",
    subTitle:
      "70% of field service managers state that finding skilled technicians is increasingly difficult, impacting service quality and response times.",
  },
  {
    category: "EXECUTION",
    image: execution_2,
    moblieImage: execution_2,
    title: "SLA Adherence",
    subTitle:
      "89% of customers stating that they want to see modern technology being used by field service technicians, as per Salesforce research.",
  },
  {
    category: "EXECUTION",
    image: execution_3,
    moblieImage: execution_3,
    title: "Route Optimization",
    subTitle:
      "Manual route planning is time consuming and often results in inconsistencies and inefficiencies.",
  },
];
export default function LoadingPage2(props: Props) {
  const [category, setCategory] = useState("MANAGEMENT");

  const handleCategoryClick = (category: any) => {
    setCategory(category);
  };

  const filterChallenges = Challenges.filter((item) => {
    if (category === "MANAGEMENT") return item.category === "MANAGEMENT";
    if (category === "PLANNING") return item.category === "PLANNING";
    if (category === "EXECUTION") return item.category === "EXECUTION";
  });

  const columnClass =
    filterChallenges.length === 2
      ? "col-lg-6 col-md-12 col-sm-12 d-flex"
      : "col-lg-4 col-md-12 col-sm-12";

  const fontsize = category === "EXECUTION" ? "font-22 fonts-600" : "font-26";
  const widthsize =
    category === "EXECUTION" ? "w-100 hx-180 pb-10" : "wx-220 hx-218";
  return (
    <>
      {/* mobile View */}
      <div className="d-block d-md-none">
        <div
          className="p-20"
          style={{
            // backgroundImage: `url(${homebanner})`,
            // backgroundRepeat: "no-repeat",
            backgroundColor: "white",
            backgroundSize: "cover",
          }}
        >
          <div className={`container navbars`}>
            <p
              className={`line-28 fonts-800 font-22 my-20 px-30 header-color font-family-roboto display-center`}
            >
              Challenges Throughout the Value Chain
            </p>
            <div
              className={`container d-flex text-grey fonts-400 mb-20 font-13 flex-gap-30 justify-content-center display-center`}
            >
              <p
                role="button"
                className={`text-grey category-item fonts-400 font-13 line-15 font-family-roboto navlinks pb-1 position-relative${
                  category === "MANAGEMENT" ? " current" : ""
                }`}
                onClick={() => handleCategoryClick("MANAGEMENT")}
              >
                MANAGEMENT
              </p>
              <p
                role="button"
                className={`text-grey category-item fonts-400 font-13 line-15 navlinks pb-1 font-family-roboto ${
                  category === "PLANNING" ? "current" : ""
                }`}
                onClick={() => handleCategoryClick("PLANNING")}
              >
                PLANNING
              </p>
              <p
                role="button"
                className={`text-grey category-item fonts-400 font-13 line-15 navlinks pb-1 font-family-roboto ${
                  category === "EXECUTION" ? "current" : ""
                }`}
                onClick={() => handleCategoryClick("EXECUTION")}
              >
                EXECUTION
              </p>
            </div>
            <div className="container px-40 px-mob-140">
              <div className="">
                {filterChallenges.map((item: any, index: any) => {
                  const splitContent = ["61%", "52%", "70%", "14%", "89%"];
                  const splitFilter = splitContent.filter((str) =>
                    item?.subTitle.includes(str)
                  );
                  const splitString = splitFilter[0];
                  const split = item?.subTitle.split(splitString);
                  const firstString = split[0];
                  const secondString = split[1];
                  return (
                    <>
                      <div key={index} className={`pb-20`}>
                        <img
                          className="w-100 h-50 pb-10"
                          src={item?.moblieImage}
                          alt="background will be here"
                        />
                        <div className="d-flex justify-content-start flex-column align-items-start wp-100">
                          <p
                            className={`font-16 text-grey fonts-600 font-family-roboto-flex mb-10 line-30`}
                          >
                            {item?.title}
                          </p>
                          <p className="text-grey font-family-roboto fonts-400 font-13 line-16">
                            {firstString}
                            {secondString && (
                              <>
                                <a className="span-color" href="#/">
                                  {splitString}
                                </a>
                                {secondString}
                              </>
                            )}
                          </p>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
              {filterChallenges.some(
                (item) => item.category === "MANAGEMENT"
              ) && (
                <p
                  className={`bg-mobile-home p-3 line-17 fonts-400 font-11 pb-20 text-grey font-family-roboto display-center radius-10`}
                >
                  <span className="span-color"> * </span>These data points are
                  generalized and can vary widely depending on specific
                  industries within the field service sector, geographic
                  location, company size, and management practices.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Website */}
      <div className="container d-none d-md-block">
        <div
          style={{
            // backgroundImage: `url(${homebanner})`,
            // backgroundRepeat: "no-repeat",
            backgroundColor: "white",
            backgroundSize: "cover",
          }}
        >
          <div className={`container navbars py-20`}>
            <p
              className={`line-35 fonts-800 font-30 py-40 header-color font-family-roboto display-center`}
            >
              Challenges Throughout the Value Chain
            </p>
            <div
              className={`container d-flex text-grey fonts-400 mb-25 font-20 flex-gap-30 justify-content-center display-center`}
            >
              <p
                role="button"
                className={`text-grey category-item fonts-400 font-20 line-23 font-family-roboto navlinks pb-1 position-relative${
                  category === "MANAGEMENT" ? " current" : ""
                }`}
                onClick={() => handleCategoryClick("MANAGEMENT")}
              >
                MANAGEMENT
              </p>
              <p
                role="button"
                className={`text-grey category-item fonts-400 font-20 line-23 navlinks pb-1 font-family-roboto ${
                  category === "PLANNING" ? "current" : ""
                }`}
                onClick={() => handleCategoryClick("PLANNING")}
              >
                PLANNING
              </p>
              <p
                role="button"
                className={`text-grey category-item fonts-400 font-20 line-23 navlinks pb-1 font-family-roboto ${
                  category === "EXECUTION" ? "current" : ""
                }`}
                onClick={() => handleCategoryClick("EXECUTION")}
              >
                EXECUTION
              </p>
            </div>
            <div
              className="container height-medium"
              style={{ height: "360px" }}
            >
              <div className="row">
                {filterChallenges.map((item: any, index: any) => {
                  const splitContent = ["61%", "52%", "70%", "14%", "89%"];
                  const splitFilter = splitContent.filter((str) =>
                    item?.subTitle.includes(str)
                  );
                  const splitString = splitFilter[0];
                  const split = item?.subTitle.split(splitString);
                  const firstString = split[0];
                  const secondString = split[1];
                  return (
                    <>
                      <div
                        key={index}
                        className={`${columnClass} flex-gap-15 px-1 mb-40`}
                      >
                        <img
                          className={`${widthsize}`}
                          src={item?.image}
                          alt="background will be here"
                        />
                        <div className="d-flex justify-content-start flex-column align-items-start wp-100">
                          <p
                            className={`${fontsize} text-grey fonts-600 font-family-roboto-flex mb-10 line-30`}
                          >
                            {item?.title}
                          </p>
                          <p className="text-grey font-family-roboto fonts-400 font-18 line-30">
                            {firstString}
                            {secondString && (
                              <>
                                <a className="span-color" href="#/">
                                  {splitString}
                                </a>
                                {secondString}
                              </>
                            )}
                          </p>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
              {filterChallenges.some(
                (item) => item.category === "MANAGEMENT"
              ) && (
                <p
                  className={`line-20 fonts-400 font-12 pb-20 text-grey font-family-roboto display-center`}
                >
                  <span className="span-color"> * </span>These data points are
                  generalized and can vary widely depending on specific
                  industries within the field service sector, geographic
                  location, company size, and management practices.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
